import type {
    IGenderDistributionData } from "app/pages/website-analysis/demographics/GenderDistributionBarChartCompared/GenderDistributionBarChartCompared";
import {
    GenderDistributionBarChartCompared
} from "app/pages/website-analysis/demographics/GenderDistributionBarChartCompared/GenderDistributionBarChartCompared";
import { GenderContainerCompare } from "app/pages/website-analysis/demographics/StyledComponents";
import type { FC } from "react";

interface IGenderDistributionCompare {
    isLoading: boolean;
    genderDistributionData: IGenderDistributionData;
    downloadExcelUrl: string;
}

export const GenderDistributionCompare: FC<IGenderDistributionCompare> = (props) => {
    const { isLoading, genderDistributionData, downloadExcelUrl } = props;
    return (
        <GenderContainerCompare>
            <GenderDistributionBarChartCompared
                data={genderDistributionData}
                isLoading={isLoading}
                downloadExcelUrl={downloadExcelUrl}
            />
        </GenderContainerCompare>
    );
};
